import React from 'react';

import { scaleImage } from '@trqk/utils';

interface Props {
    height?: number;
    width?: number;
}

const iconId = 'loading-spinner';

const originalDimensions = {
    width: 64,
    height: 64,
};

export const LoadingSpinner = (props: Props): JSX.Element => {
    const { height, width } = scaleImage(originalDimensions, props);

    return (
        <svg
            aria-labelledby={iconId}
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width={width}
            height={height}
            viewBox="0 0 128 128"
            xmlSpace="preserve"
        >
            <title id={iconId}>Loading Spinner</title>
            <g>
                <linearGradient id="linear-gradient">
                    <stop offset="0%" stopColor="#ffffff" fillOpacity="0" />
                    <stop offset="100%" stopColor="#cfd5e6" fillOpacity="1" />
                </linearGradient>
                <path
                    d="M63.85 0A63.85 63.85 0 1 1 0 63.85 63.85 63.85 0 0 1 63.85 0zm.65 19.5a44 44 0 1 1-44 44 44 44 0 0 1 44-44z"
                    fill="url(#linear-gradient)"
                    fillRule="evenodd"
                />
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 64 64"
                    to="360 64 64"
                    dur="1080ms"
                    repeatCount="indefinite"
                />
            </g>
        </svg>
    );
};
